import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=7507890d&scoped=true"
import script from "./assess.vue?vue&type=script&lang=js"
export * from "./assess.vue?vue&type=script&lang=js"
import style0 from "./assess.vue?vue&type=style&index=0&id=7507890d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7507890d",
  null
  
)

export default component.exports